

function useAuthentication() {
    const parsedQuery = new URLSearchParams(window.location.search);
    const phoneUuid = parsedQuery.get('phoneUuid');
    const token = parsedQuery.get('token');

    if (token) {
        localStorage.setItem('token', token);
        localStorage.setItem('phoneUuid', phoneUuid);
        return {isLogged: true, token: token, phoneUuid: phoneUuid};
    }

    const storedToken = localStorage.getItem('token');
    const storedPhoneUuid = localStorage.getItem('phoneUuid');
    if (storedToken) {
        return {isLogged: true, token: storedToken, phoneUuid: storedPhoneUuid};
    }

    return {isLogged: false, token: null, phoneUuid: null};
}

export default useAuthentication;
